import { useApp, hasRole } from "../context/AppContext";

export function RoleGate({ roles, children, fallback }) {
  const { user } = useApp();
  if (!hasRole(user, ...roles)) {
    return (
      <>
        {fallback ?? (
          <div className="card text-sm text-slate-500">You do not have permission to view this section.</div>
        )}
      </>
    );
  }
  return <>{children}</>;
}
